import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/(main)/men/page.tsx");
